import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { Faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { NotificationService } from '../../@domain/notification/application/notification.service';
import { AppConfig } from '../configuration/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class Logger {
    private notificationService = inject(NotificationService);
    private platformId = inject(PLATFORM_ID);
    protected appConfig = inject(AppConfig);
    private zone = inject(NgZone);
    private faro: Faro | undefined;

    constructor() {
        if (!this.appConfig.isLocal && isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                this.faro = initializeFaro({
                    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/da79791653e28fa1c84c480718401a7e',
                    app: {
                        name: `vln-${ this.appConfig.environment }`,
                        version: '1.0.0',
                        environment: 'production',
                        namespace: 'vln',
                    },
                    trackWebVitalsAttribution: true,
                    instrumentations: [
                        ...getWebInstrumentations({
                            captureConsole: true,
                            enablePerformanceInstrumentation: true,
                        }),
                        new TracingInstrumentation(),
                    ],
                })

                console.log('Session ID:', this.faro!.api.getSession()?.id);
            });
        }
    }

    public error(message: string, err: any) {
        if (this.appConfig.isLocal) {
            console.info(message, err);
        }

        this.pushError('Unhandled Error | ' + message, err);
    };

    public apiError(message: string, err: any) {
        this.pushError('API Error | ' + message, err);
        this.notificationService.error({ detail: 'Something went wrong. Please try again later.'});
    }

    public clientError(message: string, err: any) {
        this.pushError('Client Error | ' + message, err);
        this.notificationService.error({ detail: 'Something went wrong. Please try again later.' });
    }

    private pushError(message: string, err: any) {
        console.warn(message, err);
        const wrapperError = new Error(message);
        wrapperError.stack = err.stack

        this.faro?.api?.pushError(wrapperError);
    }

}
